import React, { useEffect, useState } from 'react';
import { CheckCircle, Trophy, Mail } from 'lucide-react';
import '../styles/PaymentStatus.css';

const PaymentSuccess = () => {
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get website URL for navigation
  const WEBSITE_URL = process.env.REACT_OWN_URL 
    ? process.env.REACT_OWN_URL.replace(/\/api$/, '').replace(/\/$/, '') 
    : 'http://localhost:3000';

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    const lake = urlParams.get('lake');
    const user = urlParams.get('user');

    console.log('Payment success page loaded:', { sessionId, lake, user });

    // Handle all lake types
    let lakeName = 'Tó';
    if (lake === 'balaton' || lake?.toLowerCase().includes('balaton')) {
      lakeName = 'Balaton';
    } else if (lake === 'tisza' || lake?.toLowerCase().includes('tisza')) {
      lakeName = 'Tisza-tó';
    } else if (lake === 'velencei' || lake?.toLowerCase().includes('velencei')) {
      lakeName = 'Velencei-tó';
    } else {
      lakeName = lake || 'Tó';
    }
    
    setSessionData({
      sessionId,
      lake: lakeName,
      user: decodeURIComponent(user || 'Felhasználó')
    });
    
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="payment-status-page">
        <div className="payment-status-container">
          <div className="payment-loading">
            <div className="payment-loading-spinner" />
            <p>Fizetési adatok ellenőrzése...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-status-page">
      <div className="payment-status-container">
        <div className="payment-status-card">
          {/* Header */}
          <div className="payment-status-header success">
            <div className="payment-status-icon">
              <CheckCircle size={64} color="#fff" />
            </div>
            <h1 className="payment-status-title">
              Sikeres Fizetés!
            </h1>
            <p className="payment-status-subtitle">
              {sessionData?.lake} Jutalom Csomag megvásárolva
            </p>
          </div>

          {/* Content */}
          <div className="payment-status-content">
            <div className="payment-status-details">
              <h3>
                <Trophy size={20} color="#049A63" />
                Teljesítmény részletei
              </h3>
              
              <div className="payment-detail-item">
                <strong>Teljesítő:</strong> {sessionData?.user}
              </div>
              <div className="payment-detail-item">
                <strong>Teljesített útvonal:</strong> {sessionData?.lake}
              </div>
              <div className="payment-detail-item">
                <strong>Jutalom csomag:</strong> {sessionData?.lake} Exkluzív Csomag
              </div>
            </div>

            <div className="payment-next-steps">
              <h3>
                <Mail size={20} color="#2e7d32" />
                Mi következik?
              </h3>
              
              <p>
                ✅ <strong>Digitális oklevél</strong> email-ben elküldve
              </p>
              <p>
                🎁 <strong>QR kód</strong> fagylalt beváltáshoz
              </p>
              <p>
                📧 Ellenőrizd a postafiókod (akár 2-3 percet is igénybe vehet)
              </p>
            </div>

            {/* Ice Cream Redemption Locations */}
            <div className="payment-locations-section">
              <h3 style={{ marginBottom: '1rem' }}>
                📍 Fagylalt Beváltási Helyek:
              </h3>
              
              <div style={{ 
                backgroundColor: '#f8f9fa', 
                borderRadius: '8px', 
                padding: '20px', 
                fontSize: '15px',
                lineHeight: '1.6'
              }}>
                <p style={{ margin: '0 0 16px 0' }}>
                  <strong>🏢 Budapest</strong><br/>
                  Bajcsy Zsilinszky út 49.<br/>
                  Magyarország
                </p>
                
                <p style={{ margin: '0' }}>
                  <strong>🏢 Eger</strong><br/>
                  Dobó István tér 6.<br/>
                  Magyarország
                </p>
              </div>
            </div>

            <div className="payment-transaction-info">
              <p>
                Köszönjük a vásárlást! A digitális jutalom csomag részleteit, az oklevelet és a QR kódot 
                emailben küldjük el az általad megadott címre.
              </p>
              <div className="payment-transaction-id">
                <strong>Tranzakció ID:</strong> {sessionData?.sessionId?.substring(0, 16)}...
              </div>
            </div>

            {/* Back to App Button */}
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <a
                href={WEBSITE_URL}
                className="payment-action-button primary"
              >
                Vissza a főoldalra
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
